import React from 'react';
import { Route } from 'react-router-dom'
import Tools from "../../Tools";

const AppRoute = ({ component: Component, layout: Layout, back_unique: back_unique, front_unique: front_unique, title: title, header: header, aside: Aside, ...rest }) => {
    var back_unique = Tools.changeTitleToId(back_unique ?? title);
    var front_unique = Tools.changeTitleToId(front_unique ?? title);

    return (
        <Route {...rest} render={matchProps => (
            <Layout unique={back_unique} id={front_unique} title={title} header={header} aside={Aside}>
                <Component unique={back_unique} {...matchProps}/>
            </Layout>
        )} />
    )
};

export default AppRoute;